import { Button, CustomDatePicker, Text, XStack } from '@my/ui'
import { CalendarCheck } from '@tamagui/lucide-icons'
import { DateTime } from 'luxon'
import React from 'react'

interface DueDatePickerProps {
  value: string | null
  onChange: (date: string | null) => void
  placeholder: string
}

const DatePickerFooter = ({ onClose, onClear }: { onClose: () => void; onClear: () => void }) => (
  <XStack justifyContent="space-between" paddingVertical="$2" paddingHorizontal="$2" marginTop="$2">
    <Button
      variant="outlined"
      onPress={onClose}
      paddingHorizontal="$3"
      height="$3"
      borderColor="$accentColor"
      borderRadius="$8"
    >
      <Text color="$accentColor" fontSize="$3">
        Cancel
      </Text>
    </Button>
    <Button
      variant="outlined"
      onPress={onClear}
      paddingHorizontal="$3"
      height="$3"
      borderColor="$accentColor"
      borderRadius="$8"
    >
      <Text color="$accentColor" fontSize="$3">
        Clear
      </Text>
    </Button>
  </XStack>
)

export function DueDatePicker({ value, onChange, placeholder }: DueDatePickerProps) {
  const formatDate = (date: string | null) => {
    if (!date) return ''
    return DateTime.fromISO(date).toFormat('MMM d')
  }

  const isDateInPast = (date: string | null) => {
    if (!date) return false
    const today = DateTime.now().startOf('day')
    const compareDate = DateTime.fromISO(date).startOf('day')
    return compareDate < today
  }

  const TriggerButton = ({
    value,
    placeholder,
    onPress,
  }: {
    value: string | null
    placeholder: string
    onPress: () => void
  }) => {
    const isPast = isDateInPast(value)

    return (
      <XStack
        borderWidth={value ? 2.5 : 2.5}
        borderColor={isPast ? '$red10Light' : value ? '$accentColor' : '$color5'}
        paddingVertical="$1.5"
        paddingHorizontal="$2.5"
        borderRadius="$2"
        gap="$2"
        alignItems="center"
        alignSelf="flex-start"
        flexShrink={1}
        flexGrow={0}
        maxWidth="100%"
        cursor="pointer"
        hoverStyle={{ backgroundColor: '$color1' }}
        onPress={onPress}
      >
        <CalendarCheck
          strokeWidth={2.5}
          size={16}
          color={isPast ? '$red10Light' : value ? '$accentColor' : '$color6'}
        />
        <Text
          fontSize="$3"
          fontWeight={value ? '500' : '500'}
          color={isPast ? '$red10Light' : value ? '$accentColor' : '$color6'}
        >
          {value ? formatDate(value) : placeholder}
        </Text>
      </XStack>
    )
  }

  return (
    <CustomDatePicker
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      triggerComponent={TriggerButton}
      footer={DatePickerFooter}
      popoverOffset={-210}
    />
  )
}
